//@ts-nocheck
import { Inject, Injectable } from '@angular/core';
import { Heap } from './heap-analytics';
import { HEAP_ANALYTICS_CONFIG, HeapAnalyticsConfig } from './heap-analytics-config';

declare const heap: Heap;

@Injectable({
	providedIn: 'root',
})
export class HeapAnalyticsService implements Heap {
	appid: string | undefined;
	identity: string | null | undefined;
	config: any;
	userId: string | undefined;

	constructor(@Inject(HEAP_ANALYTICS_CONFIG) private heapAnalyticsConfig: HeapAnalyticsConfig) {}

	addEventProperties(properties: any): void {
		heap.addEventProperties(properties);
	}

	addUserProperties(properties: any): void {
		heap.addEventProperties(properties);
	}

	clearEventProperties(): void {
		heap.clearEventProperties();
	}

	identify(identity: string): void {
		heap.identify(identity);
	}

	removeEventProperty(property: string): void {
		heap.removeEventProperty(property);
	}

	resetIdentity(): void {
		heap.resetIdentity();
	}

	track(event: string, properties: any | undefined): void {
		heap.track(event, properties);
	}

	load(config?: any): void {
		heap.load(this.heapAnalyticsConfig.appId, config);
	}
}
